import { HeroSection } from './sections/HeroSection';
import { FeaturedSection } from './sections/FeaturedSection';

export const Home = () => {
  return (
    <div className="min-h-screen">
      <HeroSection />
      <FeaturedSection />
    </div>
  );
};
